/** Suppress the WebView/browser default right-click menu (Back / Refresh /
 *  Save as / Print / Inspect …). It pops up whenever a right-click isn't
 *  consumed by one of the app's own React context menus — e.g. on a view
 *  widget or empty background that has no menu. This is a monitoring app, not a
 *  web page, so that menu is never wanted there.
 *
 *  The app's own context menus (TigerViewPanel widgets, the graph-set menu, …)
 *  call `preventDefault()` and render their own `<ContextMenu>`; this global
 *  listener only adds `preventDefault()` where they don't, so it never stops a
 *  custom menu from showing.
 *
 *  Native menus ARE kept on editable fields (input / textarea / contenteditable)
 *  so dialog text boxes keep their copy/paste menu — matching the standard
 *  Windows edit-control behaviour of the original MFC app. */

/** Editable targets where the native context menu should be left alone. */
function isEditable(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  if (tag === "INPUT" || tag === "TEXTAREA") return true;
  return target.isContentEditable;
}

/** contextmenu handler: cancel the native menu unless the target is editable.
 *  Exported for unit testing. */
export function handleContextMenu(e: MouseEvent): void {
  if (isEditable(e.target)) return;
  e.preventDefault();
}

/** Install the suppressor once per window (called from each window entry). */
export function installContextMenuSuppressor(): void {
  if (typeof document === "undefined") return;
  document.addEventListener("contextmenu", handleContextMenu);
}
